<template>
    <v-row class="ma-0 pa-0" align="center" justify="center">
        <v-col cols="12" class="chart_style">
            <v-chart :id="chart_id" class="chart" :option="option" autoresize></v-chart>
        </v-col>
        <v-col cols="auto" class="py-0">
            <span class="chart_title">{{ statistic_title_name }}</span>
        </v-col>
    </v-row>
</template>

<script>
    import VChart, { THEME_KEY } from 'vue-echarts';
    import "echarts";
    import { use } from 'echarts/core';
    import { CanvasRenderer } from 'echarts/renderers';
    import {
        TitleComponent,
        TooltipComponent,
        LegendComponent,
    } from 'echarts/components';

    // import {COLOR_PALETTE} from "./chart_constants.js"

    use([
        CanvasRenderer,
        TitleComponent,
        TooltipComponent,
        LegendComponent,
    ]);
    export default {
        name: 'GaugeChart',
        props: [
            'statistic_title_name',
            'value',
            'link',
            'chart_id'
        ],
        components: {
            VChart
            // GChart
        },
        provide: {
            [THEME_KEY]: 'light',
        },
        setup(props) {
            const option = {
                series: [
                    {
                    type: 'gauge',
                    progress: {
                        show: true,
                        width: 10
                    },
                    radius: '100%',
                    axisLine: {
                        lineStyle: {
                            width: 10
                        }
                    },
                    itemStyle: {
                        color: '#1230EF',
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        length: 5,
                        lineStyle: {
                            width: 2,
                            color: '#020446'
                        }
                    },
                    axisLabel: {
                        distance: 15,
                        color: '#020446',
                        fontSize: 12
                    },
                    anchor: {
                        show: true,
                        showAbove: true,
                        size: 15,
                        itemStyle: {
                            color: '#020446'
                        }
                    },
                    title: {
                        show: false
                    },
                    detail: {
                        valueAnimation: true,
                        fontSize: 40,
                        offsetCenter: [0, '80%'],
                        color: '#020446'
                    },
                    data: [
                        {
                            name: 'score',
                            value: props.value
                        }
                    ]
                    }
                ]
                };
            return {option}
        },
        methods: {
            format_data: function(dataset){
                let data = [];
                let data_titles = [];
                if(dataset != null){
                    for(let idx = 0; idx < dataset.length; idx ++){
                        if(idx > 0){
                            data.push({
                                name: dataset[idx][0],
                                value: dataset[idx][1]
                            })
                            data_titles.push(dataset[idx][0]);
                        }
                    }
                }
                this.option['series'][0]['data'] = data;
                this.option['legend']['data'] = data_titles;
            },
            open_further_details: function(){
                if(this.link){
                    this.$router.replace(this.link);
                }
            }
        }
    }
</script>

<style scoped>
    .chart_title{
        font-family: "Gothic Bold" !important;
        font-size: 10pt !important;
        line-height: 40px;

        display: block;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .chart_style{
        height: 25vh;
        font-family: "Gothic" !important;
    }
</style>